import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import { ResponseContact } from '../dto/contact.dto';


@Injectable()
export class ContactNestApi {

  private service: string = '';
  private model: string = 'Contacts';

  constructor(
    public nestApiProvider: NestApiProvider,
  ) {
  }

  public getContact(empId: string): Observable<ResponseContact> {
    const method: string = 'GET';
    const func: string = 'getContact';
    const params: any = {};
    const urlParams: any = { empId: empId };
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseContact>(method, url, params, urlParams, body);
  }


}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/contact.api.ts